module.exports = __webpack_public_path__ + "img/ronda-marker_en.f62b2585.png";